import React from 'react'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import s from './FieldError.scss'


// TODO replace with <Text message={} type="error" />
const FieldError = ({ className, message, dataTestId }) => (
  <Message
    className={cx(s.error, className)}
    text={message}
    tag="div"
    aria-live="polite"
    role="region"
    dataTestId={dataTestId}
  />
)


export default FieldError
